module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Experience.e470ca03-ps.jpg";